import { addToCart, itemCountFromSections, preorderProperties, themeRoutes } from '@theme/ca-cart-add';
import { ThemeEvents } from '@theme/events';

/* "Pairs well with" AJAX add-to-cart. */
(function () {
  if (window.__caPairsInit) return;
  window.__caPairsInit = true;

  function initRoot(root) {
    if (!root || root.dataset.caPairsReady === 'true') return;
    root.dataset.caPairsReady = 'true';

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      event.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      var drawer = document.querySelector('cart-drawer-component');
      var drawerWasOpen = !!(drawer && drawer.querySelector('dialog[open]'));

      document.dispatchEvent(
        new CustomEvent(ThemeEvents.cartAddPending, {
          bubbles: true,
          detail: { sourceId: 'ca-pairs-well-with' }
        })
      );

      addToCart({ id: variantId, quantity: 1, properties: preorderProperties(btn) })
        .then(function (result) {
          if (!result.response.ok || !result.data) throw new Error('add failed');
          return result.data;
        })
        .then(function (addData) {
          btn.classList.add('is-added');
          btn.textContent = btn.getAttribute('data-added-label') || '✓ Added';
          announce(root, btn.getAttribute('data-added-announce') || 'Item added to cart');

          var itemCount = itemCountFromSections(addData.sections);

          if (itemCount != null) {
            dispatchCartUpdate(itemCount, null, addData.sections);
            return;
          }

          var cartUrl = themeRoutes().cart_url || '/cart';
          fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              dispatchCartUpdate(cart ? cart.item_count : undefined, cart, addData.sections);
            })
            .catch(function () {
              dispatchCartUpdate(undefined, null, addData.sections);
            });
        })
        .catch(function () {
          // No detail.data: gift-card-recipient-form.js prints any cart:error data.message into its form.
          document.dispatchEvent(
            new CustomEvent(ThemeEvents.cartError, {
              bubbles: true,
              detail: { sourceId: 'ca-pairs-well-with' }
            })
          );

          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = btn.getAttribute('data-error-label') || 'Try again';

          var message = root.dataset.errorAnnounce || 'Could not add the item. Please try again.';

          if (!drawerWasOpen && drawer && typeof drawer.closeDialog === 'function') {
            // closeDialog is async: announce after it settles, while the page behind is still inert.
            Promise.resolve(drawer.closeDialog()).then(
              function () { announce(root, message); },
              function () { announce(root, message); }
            );
          } else {
            announceInDrawer(drawer, message) || announce(root, message);
          }
        });
    });
  }

  function dispatchCartUpdate(itemCount, resource, sections) {
    document.dispatchEvent(
      new CustomEvent(ThemeEvents.cartUpdate, {
        bubbles: true,
        detail: {
          resource: resource || null,
          sourceId: 'ca-pairs-well-with',
          data: {
            source: 'ca-pairs-well-with',
            itemCount: itemCount != null ? itemCount : undefined,
            sections: sections
          }
        }
      })
    );
  }

  function announce(root, message) {
    var live = root.querySelector('[data-ca-pairs-live]');
    if (live) live.textContent = message;
  }

  function announceInDrawer(drawer, message) {
    var dialog = drawer && drawer.querySelector('dialog[open]');
    var region = dialog && dialog.querySelector('[ref="liveRegion"]');
    if (!region) return false;
    region.textContent = message;
    return true;
  }

  function initAll(ctx) {
    var roots = (ctx || document).querySelectorAll('[data-ca-pairs]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
